import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import actionService from '../../services/actionService';
import ActionForm from './ActionForm';

const EditActionForm = () => {
  const { projectId, actionId } = useParams();
  const [action, setAction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAction = async () => {
      try {
        const actionData = await actionService.getAction(actionId);
        // Ensure targets are properly formatted as an array of IDs
        if (actionData.targets) {
          actionData.targets = actionData.targets.map(target => 
            typeof target === 'object' ? target._id : target
          );
        }
        setAction(actionData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching action:', error);
        setError('Failed to load action details. The action may not exist or there may be a server issue.');
        setLoading(false);
      }
    };

    if (actionId) {
      fetchAction();
    }
  }, [actionId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <FontAwesomeIcon icon={faSpinner} className="animate-spin text-4xl text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto mt-8">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
          <h3 className="font-semibold mb-2">Error Loading Action</h3>
          <p>{error}</p>
          <button 
            onClick={() => window.history.back()} 
            className="mt-3 text-red-800 underline hover:text-red-900"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (!action) {
    return (
      <div className="max-w-4xl mx-auto mt-8">
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded">
          <h3 className="font-semibold mb-2">Action Not Found</h3>
          <p>The action you're looking for doesn't exist or has been deleted.</p>
          <button 
            onClick={() => window.history.back()} 
            className="mt-3 text-yellow-800 underline hover:text-yellow-900"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <ActionForm action={action} isEditing={true} />;
};

export default EditActionForm;